import { FormControl } from "@mui/material";
import { motion } from "framer-motion";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ReactSelect from "react-select";
import CloseIcon from "../../../../components/CloseIcon/CloseIcon";
import CustomButtonV2 from "../../../../components/CustomButtonV2/CustomButtonV2.js";
import HeaderCadastro from "../../../../components/HeaderCadastro/HeaderCadastro";
import LoadingComponent from "../../../../components/LoadingComponent/LoadingComponent.tsx";
import ModalConfirmacao from "../../../../components/ModalConfirmacao/ModalConfirmacao.tsx";
import ModalUsuario from "../../../../components/ModalUsuario/ModalUsuario.tsx";
import NavbarV3 from "../../../../components/NavbarV3/NavbarV3.tsx";
import SemAutorizacao from "../../../../components/SemAutorizacao/SemAutorizacao";
import TabelaV2 from "../../../../components/TabelaV2/TabelaV2";
import ToastErro from "../../../../components/Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import NomeTabelaRedux from "../../../../contexts/NomeTabela";
import RequestControllerRedux from "../../../../contexts/RequestController";
import TabelaRedux from "../../../../contexts/Tabela";
import DadosUsuarioRedux from "../../../../contexts/Usuario";
import { getCidadeEstadoComSigla } from "../../../../services/ModuloGerenciador/CidadeEstado";
import {
	getRegras,
	getUnidadeEmbarqueDependencias,
} from "../../../../services/ModuloGerenciador/Geral.ts";
import {
	cadastraUnidadeEmbarque,
	deleteUnidadeEmbarquePorId,
	editaUnidadeEmbarquePorId,
	getUnidadeEmbarque,
	getUnidadeEmbarquePorId,
} from "../../../../services/ModuloGerenciador/UnidadeEmbarque";
import { verificaDadosUsuarioRedux } from "../../../../services/ModuloGerenciador/Usuario";
import "./UnidadeEmbarque.css";

function UnidadeEmbarque(props) {
	const { dadosUsuarioRedux, setDadosUsuarioRedux } =
		useContext(DadosUsuarioRedux);

	const { dadosRequestControllerRedux, setDadosRequestControllerRedux } =
		useContext(RequestControllerRedux);

	const { dadosTabelaRedux } = useContext(NomeTabelaRedux);

	const { tabelaRedux, setTabelaRedux } = useContext(TabelaRedux);

	const [dadosTabela, setDadosTabela] = useState([]);

	const [telaCadastro, setTelaCadastro] = useState(false);

	const [editando, setEditando] = useState(false);

	const [loading, setLoading] = useState(true);

	const [values, setValues] = useState([]);

	const [validator, setValidator] = useState([]);

	const [semAutorizacao, setSemAutorizacao] = useState(true);

	const [open, setOpen] = useState(false);

	const [textoSucesso, setTextoSucesso] = useState("");

	const [textoErro, setTextoErro] = useState("");

	const [listaCidades, setListaCidades] = useState([]);

	const [listaCidadesCompleta, setListaCidadesCompleta] = useState([]);

	const [frota, setFrota] = useState(["Sim", "Não"]);

	const [valuesFiltro, setValuesFiltro] = useState({});

	const handleClose = (value) => {
		setOpen(false);
	};

	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const handleCloseToastSucesso = (value) => {
		setOpenToastSucesso(false);
	};

	const [openToastErro, setOpenToastErro] = useState(false);

	const handleCloseToastErro = (value) => {
		setOpenToastErro(false);
	};

	const [openUsuario, setOpenUsuario] = useState(false);

	const handleCloseUsuario = (value) => {
		setOpenUsuario(false);
	};

	const navigate = useNavigate();

	const buscarDependencias = async () => {
		setLoading(true);
		await getUnidadeEmbarqueDependencias(dadosUsuarioRedux.token)
			.then((result) => {
				setListaCidades(result.data.cidadeEstados);
				setListaCidadesCompleta(result.data.cidadeEstados);
				setDadosTabela(result.data.unidEmbarques);
				setTabelaRedux({});
				setTimeout(() => {
					setLoading(false);
				}, 3000);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const buscarCidadeEstado = async () => {
		setLoading(true);
		await getCidadeEstadoComSigla(dadosUsuarioRedux.token)
			.then((result) => {
				setListaCidades(result.data);
				setListaCidadesCompleta(result.data);
				setTabelaRedux({});
				setLoading(false);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const buscarUnidadeEmbarque = async () => {
		setLoading(true);
		await getUnidadeEmbarque(dadosUsuarioRedux.token).then((result) => {
			setDadosTabela(result.data);
			setTabelaRedux({});
		});
	};

	const cadastrar = async () => {
		if (
			(values.nome !== "" ||
				values.cidadeEstadoid !== "" ||
				values.frota !== "") &&
			validator.nome === "true" &&
			validator.cidadeEstadoid === "true" &&
			validator.frota === "true"
		) {
			if (values.frota === "Sim") values.frota = true;
			if (values.frota === "Não") values.frota = false;
			setLoading(true);
			await cadastraUnidadeEmbarque(values, dadosUsuarioRedux.token)
				.then((result) => {
					if (result.status === 200) {
						buscarDependencias();
						setDadosRequestControllerRedux("Fechar Modal Unidade");
						setTabelaRedux({});
						setTextoSucesso("Cadastrado Com Sucesso");
						setOpenToastSucesso(true);
					}
				})
				.catch((error) => {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				});
		} else {
			setTextoErro("Há campos sem preencher!");
			setOpenToastErro(true);
			setLoading(false);
		}
	};

	const editar = async () => {
		if (values.frota === "Sim") values.frota = true;
		if (values.frota === "Não") values.frota = false;
		setLoading(true);
		await editaUnidadeEmbarquePorId(values, dadosUsuarioRedux.token)
			.then((result) => {
				if (result.status === 200) {
					buscarDependencias();
					setTabelaRedux({});
					setTextoSucesso("Cadastrado Com Sucesso");
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const preencherDadosEditando = async (result) => {
		const cidadeSelecionado = listaCidades.find(
			(option) => option.idCidadeEstado === result.data.cidadeEstadoid
		);
		if (cidadeSelecionado) {
			setValuesSelect((current) => ({
				...current,
				cidadeEstadoid: cidadeSelecionado,
			}));
		}
		let frota;
		if (result.frota === true) {
			frota = "Sim";
		} else {
			frota = "Não";
		}
		const frotaSelecionado = opcoesFrota.find(
			(option) => option.value === frota
		);
		if (frotaSelecionado) {
			setValuesSelect((current) => ({ ...current, frota: frotaSelecionado }));
		}
	};

	const buscarUnidadeEmbarquePorId = async () => {
		setLoading(true);
		await getUnidadeEmbarquePorId(
			tabelaRedux.colunaSelecionada,
			dadosUsuarioRedux.token
		)
			.then(async (result) => {
				if (result.status === 200) {
					if (editando) {
						if (result.data.frota === true) result.data.frota = "Sim";
						if (result.data.frota === false) result.data.frota = "Não";
						await preencherDadosEditando(result);
						setValues(result.data);
						setLoading(false);
					}
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const buscarUnidadeEmbarquePorIdModal = async (id) => {
		setLoading(true);
		await getUnidadeEmbarquePorId(id, dadosUsuarioRedux.token)
			.then(async (result) => {
				if (result.status === 200) {
					if (result.data.frota === true) result.data.frota = "Sim";
					if (result.data.frota === false) result.data.frota = "Não";
					await preencherDadosEditando(result);
					setValues(result.data);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const deletarUnidadeEmbarquePorId = async () => {
		setLoading(true);
		await deleteUnidadeEmbarquePorId(
			tabelaRedux.colunaSelecionada,
			dadosUsuarioRedux.token
		)
			.then((result) => {
				if (result.status === 200) {
					buscarDependencias();
					setTabelaRedux({});
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	useEffect(() => {
		verificaDadosUsuarioRedux(dadosUsuarioRedux, setDadosUsuarioRedux);
		setValues((current) => ({
			...current,
			usuario: dadosUsuarioRedux.usuario.usuario,
		}));
		setValidator((current) => ({ ...current, nome: "false" }));
		setValidator((current) => ({ ...current, cidadeEstadoid: "false" }));
		setValidator((current) => ({ ...current, frota: "false" }));
	}, [loading]);

	useEffect(() => {
		if (editando) {
			buscarUnidadeEmbarquePorId();
		}
	}, [editando]);

	useEffect(() => {
		buscarDependencias();
	}, []);

	useEffect(() => {
		if (props.idAtual) {
			buscarUnidadeEmbarquePorIdModal(props.idAtual);
		}
	}, [listaCidades]);

	useEffect(() => {
		if (!!props.telaCadastro) {
			setTelaCadastro(true);
		}
	}, [props.telaCadastro]);

	useEffect(() => {
		if (dadosUsuarioRedux.regras !== undefined) {
			dadosUsuarioRedux.regras.forEach((element) => {
				if (element == "Uso Comum") {
					setSemAutorizacao(false);
				}
			});
		} else {
			verificaDadosUsuarioRedux(dadosUsuarioRedux, setDadosUsuarioRedux);
			getRegras(
				dadosUsuarioRedux.token,
				dadosUsuarioRedux.usuario.idUsuario
			).then((result) => {
				let regras = [];
				result.data.forEach((dado) => {
					regras.push(dado.regras.regra);
					if (dado.regras.regra == "Uso Comum") {
						setSemAutorizacao(false);
					}
				});
				dadosUsuarioRedux.regras = regras;
				setDadosUsuarioRedux(dadosUsuarioRedux);
			});
		}
	});

	const [valuesSelect, setValuesSelect] = useState([]);

	const labelCidadeEstado = (data) => (
		<div>
			{data.cidade} - {data.estado}
		</div>
	);

	const estiloCidadeEstado = {
		control: (provided) => ({
			...provided,
			minHeight: "30px",
			border: "none",
			borderRadius: "7px",
			border: "1px solid var(--Background-Input, #F2F2F2)",
			background: "var(--Background-Input, #F2F2F2)",
			"&:hover": {
				background: "#F0F6FF",
			},
		}),
		placeholder: (provided) => ({
			...provided,
			color: "var(--Placeholder-Color, #888)",
			fontSize: "12px",
		}),
		menu: (provided) => ({
			...provided,
			width: "max-content",
			minWidth: props.classeCss ? props.classeCss : "270px",
		}),
		singleValue: (provided) => ({
			...provided,
			fontSize: "13px", // ajuste o tamanho da fonte conforme desejado
		}),
		option: (provided) => ({
			...provided,
			fontSize: "13px", // ajuste o tamanho da fonte conforme desejado
		}),
	};

	const opcoesCidadeEstado = listaCidades.map((data) => ({
		value: data.idCidadeEstado,
		label: `${data.cidade} - ${data.estado}`,
		...data,
	}));

	const labelFrota = (data) => <div>{data.opcao}</div>;

	const opcoesFrota = dadosTabelaRedux.Opcoes.map((data) => ({
		value: data.opcao,
		label: data.opcao,
		...data,
	}));

	const estiloFrota = {
		control: (provided) => ({
			...provided,
			minHeight: "30px",
			border: "none",
			borderRadius: "7px",
			border: "1px solid var(--Background-Input, #F2F2F2)",
			background: "var(--Background-Input, #F2F2F2)",
			"&:hover": {
				background: "#F0F6FF",
			},
		}),
		placeholder: (provided) => ({
			...provided,
			color: "var(--Placeholder-Color, #888)",
			fontSize: "12px",
		}),
		menu: (provided) => ({
			...provided,
			width: "max-content",
			minWidth: props.classeCss ? props.classeCss : "250px",
		}),
		singleValue: (provided) => ({
			...provided,
			fontSize: "13px", // ajuste o tamanho da fonte conforme desejado
		}),
		option: (provided) => ({
			...provided,
			fontSize: "13px", // ajuste o tamanho da fonte conforme desejado
		}),
	};

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			{semAutorizacao ? (
				<>
					{props.navbar ? <></> : <NavbarV3 selecionado="Unidade Embarque" />}
					<SemAutorizacao></SemAutorizacao>
				</>
			) : (
				<div>
					{props.navbar ? <></> : <NavbarV3 selecionado="Unidade Embarque" />}
					{!loading ? (
						<motion.div
							initial={{ opacity: 0 }}
							animate={{ opacity: 1 }}
							exit={{ opacity: 0 }}
						>
							{!telaCadastro ? (
								<div className="embarques">
									<div className="header-cliente-v2">
										<div className="flex">
											<p className="indicador-principal-embarque-v2">
												Unidade Viagens
											</p>
										</div>
									</div>
									<TabelaV2
										setTelaCadastro={setTelaCadastro}
										setEditando={setEditando}
										classeSelecionado="idUnidadeEmbarque"
										nomeClasse1="outer-wrapper-cidade"
										nomeClasse2="table-wrapper-cidade-v2"
										colunas={dadosTabelaRedux.UnidadeEmbarque}
										dados={dadosTabela}
									/>
									<div className="container-botoes-cliente">
										<div>
											<CustomButtonV2
												classCss="custom-button-cadastrar"
												classText="button-texto-cadastrar"
												icone="iconeSave"
												titulo="Cadastrar"
												cor="#0946B8"
												valor={values}
												onClick={() => {
													setTelaCadastro(true);
													setEditando(false);
												}}
											/>
											<CustomButtonV2
												classCss="custom-button-editar"
												classText="button-texto-editar"
												titulo="Editar"
												icone="iconeEdit"
												cor="#CDCDCD"
												valor={values}
												onClick={() => {
													if (tabelaRedux.colunaSelecionada) {
														setTelaCadastro(true);
														setEditando(true);
													} else {
														setTextoErro("Selecione Uma Coluna");
														setOpenToastErro(true);
													}
												}}
											/>
											<CustomButtonV2
												classCss="custom-button-deletar"
												classText="button-texto-cadastrar"
												titulo="Deletar"
												icone="iconeDelete"
												cor="#DC2D2D"
												valor={values}
												onClick={() => {
													if (tabelaRedux.colunaSelecionada) {
														setOpen(true);
														setTextoSucesso("Deletado Com Sucesso");
													} else {
														setTextoErro("Selecione Uma Coluna");
														setOpenToastErro(true);
													}
												}}
											/>
										</div>
										<div>
											<CustomButtonV2
												classCss="custom-button-user"
												classText="button-texto-user"
												titulo="Obter Usuário"
												cor="#FFFFFF"
												valor={values}
												onClick={() => {
													if (tabelaRedux.usuarioAlteracao) {
														setOpenUsuario(true);
													} else {
														setTextoErro("Selecione Uma Coluna");
														setOpenToastErro(true);
													}
												}}
											/>
										</div>
									</div>
								</div>
							) : (
								<div>
									{!props.desabilitar ? (
										<div className="indicadores">
											<p className="indicador-emb">
												{"Dados de Unidade Embarque / "}
											</p>
											{editando ? (
												<p className="indicador-emb">
													{"Detalhes de Unidade Embarque"}
												</p>
											) : (
												<p className="indicador-emb">
													{"Cadastro de Unidade Embarque"}
												</p>
											)}
										</div>
									) : (
										<></>
									)}
									<div className="flex">
										{!props.botaoVoltar ? (
											<div className="flex-emb">
												{editando ? (
													<HeaderCadastro texto="Detalhes de Unidade Embarque" />
												) : (
													<HeaderCadastro texto="Cadastro de Unidade Embarque" />
												)}
												{props.botaoFechar !== false && (
													<CloseIcon
														onClick={() => {
															setValues({});
															setTelaCadastro(false);
															setEditando(false);
															setTabelaRedux({});
														}}
													/>
												)}
											</div>
										) : (
											<></>
										)}
									</div>
									<div className="flex-column">
										<div className="container-select-emb">
											<div className="rota-div-2">
												<div className="coluna-emb">
													<div className="principal">
														<p className="input-label-emb" htmlFor="descricao">
															Unidade Embarque:
														</p>
														<input
															type="text"
															className="input-emb"
															style={{ width: "270px" }}
															onChange={(e) => {
																setValues((current) => ({
																	...current,
																	nome: e.target.value,
																}));
																setValidator((current) => ({
																	...current,
																	nome: "true",
																}));
															}}
															placeholder="Ex: TS Too"
															value={values.nome}
															disabled={props.desabilitar}
														/>
													</div>
												</div>
											</div>
											<div className="rota-div-2">
												<div className="coluna-emb">
													<div className="principal">
														<p className="input-label-emb" htmlFor="descricao">
															Cidade/Estado Origem:
														</p>
														<FormControl sx={{ width: 270 }}>
															<ReactSelect
																value={valuesSelect.cidadeEstadoid}
																isDisabled={props.desabilitar}
																options={opcoesCidadeEstado}
																formatOptionLabel={labelCidadeEstado}
																styles={estiloCidadeEstado}
																placeholder="Selecione"
																noOptionsMessage={() => "Não há mais opções"}
																onChange={(selectedOption) => {
																	if (selectedOption) {
																		setValues((current) => ({
																			...current,
																			cidadeEstadoid:
																				selectedOption.idCidadeEstado,
																		}));
																		setValuesSelect((current) => ({
																			...current,
																			cidadeEstadoid: selectedOption,
																		}));
																		setValidator((current) => ({
																			...current,
																			cidadeEstadoid: "true",
																		}));
																	}
																}}
															/>
														</FormControl>
													</div>
												</div>
											</div>
											<div className="rota-div-2">
												<div className="coluna-emb">
													<div className="principal">
														<p className="input-label-emb" htmlFor="descricao">
															Frota:
														</p>
														<FormControl sx={{ width: 270 }}>
															<ReactSelect
																value={valuesSelect.frota}
																options={opcoesFrota}
																formatOptionLabel={labelFrota}
																styles={estiloFrota}
																placeholder=""
																noOptionsMessage={() => "Não há mais opções"}
																onChange={(selectedOption) => {
																	if (selectedOption) {
																		setValues((current) => ({
																			...current,
																			frota: selectedOption.opcao,
																		}));
																		setValuesSelect((current) => ({
																			...current,
																			frota: selectedOption,
																		}));
																		setValidator((current) => ({
																			...current,
																			frota: "true",
																		}));
																	}
																}}
															/>
														</FormControl>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div className="botoes-embalagem">
										{editando ? (
											<CustomButtonV2
												classCss="custom-button-cadastrar"
												classText="button-texto-cadastrar"
												icone="iconeSave"
												titulo="Salvar"
												cor="#0946B8"
												valor={values}
												onClick={() => {
													editar();
													setTelaCadastro(false);
													setEditando(false);
													setValues({});
													setValuesSelect({});
												}}
											/>
										) : (
											<>
												{!props.desabilitar ? (
													props.botaoCadastrar ? (
														<CustomButtonV2
															classCss="custom-button-cadastrar"
															classText="button-texto-cadastrar"
															icone="iconeSave"
															titulo="Salvar"
															cor="#0946B8"
															valor={values}
															onClick={() => {
																if (
																	values.nome !== "" &&
																	values.cidadeEstadoid !== "" &&
																	values.frota !== "" &&
																	validator.nome === "true" &&
																	validator.cidadeEstadoid === "true" &&
																	validator.frota === "true"
																) {
																	cadastrar();
																	setValues({});
																	setValuesSelect({});
																} else {
																	setTextoErro("Há campos sem preencher!");
																	setOpenToastErro(true);
																}
															}}
														/>
													) : (
														<CustomButtonV2
															classCss="custom-button-cadastrar"
															classText="button-texto-cadastrar"
															icone="iconeSave"
															titulo="Salvar"
															cor="#0946B8"
															valor={values}
															onClick={() => {
																if (
																	values.nome !== "" &&
																	values.cidadeEstadoid !== "" &&
																	values.frota !== "" &&
																	validator.nome === "true" &&
																	validator.cidadeEstadoid === "true" &&
																	validator.frota === "true"
																) {
																	cadastrar();
																	setValues({});
																	setValuesSelect({});
																	setTelaCadastro(false);
																} else {
																	setTextoErro("Há campos sem preencher!");
																	setOpenToastErro(true);
																}
															}}
														/>
													)
												) : (
													<></>
												)}
											</>
										)}
										{props.botaoVoltar ? (
											<></>
										) : (
											<CustomButtonV2
												classCss="custom-button-cancelar"
												classText="button-texto-cancelar"
												titulo="Cancelar"
												cor="#0946B8"
												valor={values}
												onClick={() => {
													setValues({});
													setValuesSelect({});
													setTelaCadastro(false);
													setEditando(false);
													setTabelaRedux({});
												}}
											/>
										)}
									</div>
								</div>
							)}
							<div>
								<ModalConfirmacao
									titulo="Deletar"
									texto="Deseja Deletar?"
									tituloConfirmar="Confirmar"
									tituloCancelar="Cancelar"
									open={open}
									onClose={handleClose}
									onClick={deletarUnidadeEmbarquePorId}
								/>
								<ModalUsuario
									titulo="Usuário"
									tituloConfirmar="OK"
									open={openUsuario}
									onClose={handleCloseUsuario}
								/>
							</div>
							<div>
								<ToastSucesso
									texto={textoSucesso}
									open={openToastSucesso}
									onClose={handleCloseToastSucesso}
								/>
								<ToastErro
									texto={textoErro}
									open={openToastErro}
									onClose={handleCloseToastErro}
								/>
							</div>
						</motion.div>
					) : (
						<LoadingComponent />
					)}
				</div>
			)}
		</motion.div>
	);
}
export default UnidadeEmbarque;
